import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import FloatLabelInput from "../../../components/FloatingLabel";
import BottomMessagePopUp from "../../../components/BottomMessagePopUp";
import useGetVehicleInfo from "../../../store/selectors/get-vehicle-info";
import { getVehicleInfo } from "../../../utils/backend";
import useGetCarPlan from "../../../store/selectors/get-car-plan-quote";

const AddOnDrivers = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const getVehicleInfo = useGetVehicleInfo();
	const selectedPlan = useGetCarPlan();

	const [isModalVisible, setIsModalVisible] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");
	const [isErrorVisible, setIsErrorVisible] = useState(false);
	const showErrorMessage = (msg) => {
		setErrorMessage(msg);
		setIsErrorVisible(true);
	};

	const selectedAddOn = location.state?.addOn;

	const determineDriverCode = (selectedAddOn) => {
		if (!selectedAddOn || !selectedAddOn.code) return "04"; // Default prefix

		// Set default code based on add-on type
		if (selectedAddOn.code === "ALD") return "04";
		if (selectedAddOn.code === "AND") return "01";

		return "04"; // Default case
	};

	const normalizeDrivers = (drivers, selectedAddOn) => {
		const defaultDriverCode = determineDriverCode(selectedAddOn);

		return drivers.map((driver, index) => {
			if (typeof driver === "string") {
				return { code: defaultDriverCode, name: driver };
			} else {
				return { ...driver, code: defaultDriverCode };
			}
		});
	};

	const initialDrivers = normalizeDrivers(
		JSON.parse(localStorage.getItem("drivers")) || [
			{
				code: determineDriverCode(selectedAddOn),
				name: getVehicleInfo?.owner_name || "",
			},
		],
		selectedAddOn
	);
	const [drivers, setDrivers] = useState(initialDrivers);

	useEffect(() => {
		// Save to localStorage whenever drivers change
		localStorage.setItem("drivers", JSON.stringify(drivers));
	}, [drivers]);

	if (!selectedAddOn) {
		return (
			<div className="content">
				<h3>No Add-on Selected</h3>
				<Button label="Go Back" onClick={() => navigate(-1)} />
			</div>
		);
	}

	const handleInputChange = (index, field, value) => {
		const newDrivers = [...drivers];
		newDrivers[index] = {
			...newDrivers[index],
			code: determineDriverCode(selectedAddOn),
			[field]: value
		};
		setDrivers(newDrivers);
	};

	const addDriverField = () => {
		const newDriver = {
			code: determineDriverCode(selectedAddOn),
			name: "",
		};
		setDrivers([...drivers, newDriver]);
	};

	const removeDriverField = (index) => {
		const newDrivers = drivers.filter((_, i) => i !== index);
		setDrivers(newDrivers);
	};

	const handleReturnClick = (e) => {
		e.preventDefault();
		const queryParameters = new URLSearchParams(window.location.search);
		const policyId = queryParameters.get("policy_id");

		navigate(
			policyId
				? `/get-quote/add-on-others?policy_id=${policyId}`
				: `/get-quote/add-on-others`,
			{
				replace: true,
				state: {
					...selectedAddOn,
					drivers, // Pass the sum_insured value here
				},
			}
		);
	};

	return (
		<div className="content">
			<div className="get-quote-container">
				<h3>{`Drivers for ${selectedAddOn.title}`}</h3>

				<div className="add-on-details border-radius-10 w-100 mb-8rem">
					<Button
						label="Add Driver"
						className="btn-secondary-fill w-100 add-nominate-button mb-2"
						onClick={addDriverField}
					/>

					{drivers.map((driver, index) => (
						<div
							key={index}
							className="mb-2 d-flex align-items-center"
						>
							<FloatLabelInput
								label={
									selectedPlan.insurer_name !== "TOKIO MARINE" && index === 0
										? "Owner Name"
										: `Driver ${index + 1} Name`
								}
								value={driver.name}
								onChange={(e) =>
									handleInputChange(index, 'name', e.target.value)
								}
								type="text"
								disabled={selectedPlan.insurer_name !== "TOKIO MARINE" && index === 0}
							/>
							{(selectedPlan.insurer_name === "TOKIO MARINE" || selectedPlan.insurer_name === "TAKAFUL IKHLAS") && (
								<FloatLabelInput
									label="Identification Number"
									value={driver.id_no}
									onChange={(e) =>
										handleInputChange(index, 'id_no', e.target.value)
									}
									placeholder=""
								/>
							)}
							{index > 0 && (
								<Button
									label="Remove"
									className="p-button-danger w-100 mt-2"
									onClick={() => removeDriverField(index)}
								/>
							)}
						</div>
					))}
				</div>

				<div className={`sticky-bottom `}>
					<div className="d-flex flex-row flex-wrap justify-content-between align-items-center">
						{/* Selected Plan and Logo Section */}
						<div className="plan-details">
							<span className="text-left formatted-text">
								{`Selecting Add-Ons for`}
							</span>
							<br />
							<span className="fw-bold color-heading">
								{selectedAddOn.title}
							</span>
							<p className="my-0 fw-bold insurer-name"></p>
						</div>
						<div className="col-sm-6 w-50"></div>
					</div>
					<hr />
					<Button
						label="Return add-ons"
						className="btn-primary"
						onClick={(e) => handleReturnClick(e)}
					/>
					<BottomMessagePopUp
						message={errorMessage}
						type="error"
						isVisible={isErrorVisible}
						onClose={() => setIsErrorVisible(false)}
					/>
				</div>
			</div>
		</div>
	);
};

export default AddOnDrivers;
